import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/returns.scss";

function Returns() {
  const returns = siteConfig.returns || {};
  const returnEmail = returns.email || siteConfig.contact?.email;

  return (
    <main className="content-page policy-page returns-page">
      <header className="page-hero">
        <div className="page-shell page-hero__content">
          <p className="eyebrow">Returns &amp; refunds</p>
          <h1>We want every order to feel right.</h1>
          <p className="page-hero__lede">
            If something is not as expected, tell the {siteConfig.brandName}{" "}
            team and we will help find a fair solution.
          </p>
        </div>
      </header>

      <section className="page-section page-shell returns-intro">
        <div className="returns-intro__highlight">
          <span aria-hidden="true">100%</span>
          <p>{returns.guarantee || "satisfaction guarantee"}</p>
        </div>
        <div className="prose">
          <h2>Our return promise</h2>
          <p>
            If a product arrives damaged, incorrect, spoiled, or simply does not
            meet your expectations, contact us promptly with your order number.
            We will review the issue and arrange an appropriate replacement,
            credit, or refund.
          </p>
          <p>
            Because food safety matters, please do not mail food back unless our
            customer care team asks you to. Keep the product and shipping
            packaging until we have replied.
          </p>
        </div>
      </section>

      <section className="page-section page-section--tinted">
        <div className="page-shell policy-layout">
          <nav className="policy-nav" aria-label="On this page">
            <p className="eyebrow">On this page</p>
            <a href="#start-return">Report an issue</a>
            <a href="#damaged-items">Damaged items</a>
            <a href="#return-shipping">Return shipping</a>
            <a href="#refunds">Refund timing</a>
          </nav>

          <div className="prose policy-copy">
            <section id="start-return">
              <h2>How to start a return</h2>
              <ol>
                <li>
                  Contact us promptly with your order number and the item that
                  needs attention.
                </li>
                <li>
                  Share a short description and, for shipping damage, clear
                  photos of the product, box, and label.
                </li>
                <li>
                  Wait for the replacement, refund, or return instructions from
                  our customer care team before mailing anything.
                </li>
              </ol>
              <p>
                {returnEmail ? (
                  <a href={`mailto:${returnEmail}?subject=Return request`}>
                    Email {returnEmail} to begin
                  </a>
                ) : (
                  <Link to="/contact">Contact customer care to begin</Link>
                )}
                .
              </p>
            </section>

            <section id="damaged-items">
              <h2>Damaged, incorrect, or spoiled items</h2>
              <p>
                Report a delivery problem as soon as you notice it. Include your
                order number, a description of the issue, and photos of the
                product, shipping box, and label. Do not discard the item or
                packaging until we reply.
              </p>
              <p>
                When an item is confirmed damaged, defective, spoiled on
                arrival, or sent in error, we will offer an appropriate
                replacement or refund at no additional cost. Availability may
                determine which remedy is possible.
              </p>
            </section>

            <section id="return-shipping">
              <h2>Return shipping</h2>
              <p>
                If we ask you to return a confirmed damaged, defective, or
                incorrect item, {siteConfig.brandName} will provide the shipping
                instructions and cover the approved return cost. Terms for any
                other authorized return will be shared before you send it.
              </p>
            </section>

            <section id="refunds">
              <h2>Refunds and replacements</h2>
              <p>
                We inspect eligible returns after receipt. Approved refunds are
                sent to the original payment method, normally within 5–10
                business days of inspection. Your bank may need additional time
                to post the credit. Gift recipients may receive store credit
                instead of a refund to the purchaser’s card.
              </p>
              <p>
                Shipping questions are covered in our{" "}
                <Link to="/shipping">shipping and delivery policy</Link>.
              </p>
            </section>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Returns;
